import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/main.less";
import ElementUI from "element-ui";
require("./util/filter");

Vue.use(ElementUI);
Vue.config.productionTip = false;

let vue;

vue = new Vue({
    router,
    render: h => h(App)
}).$mount("#app");

export { vue };
